var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex-page"},[_c('a-spin',{attrs:{"tip":"授权中...","size":"large"}},[_c('div',{staticClass:"spin-content"})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }